"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tile = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const react_router_dom_1 = require("react-router-dom");
const useFetchSvg_1 = __importDefault(require("../../../common/helpers/Hooks/useFetchSvg"));
;
const CardWrapper = styled_components_1.default.div `
  .MuiCardContent-root {
    text-align: center;
    height: 80px;
    display: flex;
    align-items: center;
  }

  .display-flex {
    display: flex;
    justify-content: start;
    padding: 3px;
  }

  .card-image {
    width: 122px;
    border-radius: 5px;
  }
`;
const CardTitle = styled_components_1.default.p `
  color: #212121;
  font-weight: 200;
  font-size: 1rem;
  margin: 0 auto;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 120px;
  @media (min-width: 1024px) {
    max-width: 152px;
  }
`;
const TileWrapper = styled_components_1.default.div `
  height: 0;
  overflow: hidden;
  padding-top: 62.5%;
  position: relative;
  border-radius: 10px;
  border: 1px solid rgba(60, 60, 60, 0.1);
  background-color: ${(props) => {
    /* eslint-disable prefer-destructuring */
    const { position, theme } = props;
    if (!position && position !== 0) {
        return theme.palette.mainAppColor.main;
    }
    const colorTiles = theme.palette.colorTiles;
    const chosenColor = colorTiles[position % colorTiles.length];
    return chosenColor;
    /* eslint-disable prefer-destructuring */
}};
`;
const TileContent = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 5px;

  .sizing {
    height: 64%;
  }
`;
const SvgWrapper = styled_components_1.default.div `
  height: 64%;

  > div {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  svg {
    height: 65%;
    width: auto;
    @media (max-width: 479px) {
      max-height: 48px;
      max-width: 48px;
      width: 100%;
    }
    path,
    circle {
      fill: ${(props) => props.theme.palette.mainAppColor.contrastText};
    }
  }

  &.svg-temp-fix {
    path:first-of-type {
      fill: unset;
    }
  }
`;
const TileImage = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${(props) => `url(${props.image} )`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;
const TileImageCaption = styled_components_1.default.div `
  z-index: 1;
  position: absolute;
  width: 100%;
  height: 36%;
  padding: 0 5px;

  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  > div {
    color: #fff;
    text-shadow: 0px 1px black;
  }
`;
const TileTitle = styled_components_1.default.div `
  color: ${(props) => props.theme.palette.mainAppColor.contrastText};
  font-size: 1rem;
  line-height: 18px;
  max-height: 36px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
const TileLink = styled_components_1.default.div `
  cursor: pointer;
`;
const TileCaptionWrapper = styled_components_1.default.div `
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.3) 0%,
    rgba(0, 0, 0, 0.1) 50%,
    rgba(0, 0, 0, 0) 100%
  );
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2;
`;
const Tile = (props) => {
    const { image, svg, title, withCard, withIcon, withBackgroundImage, location, destination, history, position, tileClassName, isRenderOnBrandLevel, navigationType, } = props;
    const handleTileClick = () => {
        if (destination) {
            const { url, type } = destination;
            switch (type) {
                case "internal":
                    history.push({
                        pathname: url,
                        search: location.search,
                    });
                    break;
                case "deeplink":
                    history.push({
                        pathname: new URL(url).pathname,
                        search: location.search,
                    });
                    break;
                default:
                    window.open(url, "_blank");
                    break;
            }
        }
    };
    const renderTile = () => {
        if (withCard && image) {
            return (react_1.default.createElement(CardWrapper, null,
                react_1.default.createElement(material_1.Card, { className: ` ${isRenderOnBrandLevel ? "" : "no-box-shadow"}` },
                    react_1.default.createElement(material_1.CardActionArea, { className: ` ${isRenderOnBrandLevel ? "" : "display-flex card-action-area"}` },
                        react_1.default.createElement(material_1.CardMedia, { component: "img", image: image, className: ` ${isRenderOnBrandLevel ? "" : "card-image"}` }),
                        react_1.default.createElement(material_1.CardContent, null,
                            react_1.default.createElement(CardTitle, null, title))))));
        }
        // We use this because we get a lot of different svg structures, delete it when the correct svg is added
        const temporarySvgFix = svg && svg.includes("tab_spa") ? "svg-temp-fix" : "";
        if (withIcon && svg) {
            const loadedSvg = (0, useFetchSvg_1.default)(svg);
            return (react_1.default.createElement(TileWrapper, { position: position },
                react_1.default.createElement(TileContent, { className: "with-svg" },
                    react_1.default.createElement(SvgWrapper, { className: temporarySvgFix },
                        react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                                __html: loadedSvg,
                            } })),
                    react_1.default.createElement(TileTitle, null, title))));
        }
        if (withBackgroundImage) {
            return (react_1.default.createElement(TileWrapper, { position: position },
                react_1.default.createElement(TileContent, null,
                    react_1.default.createElement(TileImage, { image: image }),
                    react_1.default.createElement("div", { className: "sizing" }),
                    react_1.default.createElement(TileCaptionWrapper, null,
                        react_1.default.createElement(TileImageCaption, null,
                            react_1.default.createElement(TileTitle, null, title))))));
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    };
    return (react_1.default.createElement(TileLink, { onClick: handleTileClick, className: tileClassName, id: navigationType ? `aqa_home_screen_${navigationType}` : null }, renderTile()));
};
exports.Tile = Tile;
exports.default = (0, react_router_dom_1.withRouter)(exports.Tile);
